"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var cache = [];
exports.default = cache;
//# sourceMappingURL=cache.js.map